import {useConfig} from '@aboutyou/config';
import {ProductsSection as ProductsSectionType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation_page/sections.types';
import {TrackComponentParamsType} from '@aboutyou/tracking';
import {
  mediaTabletAndUp,
  RowSection,
  SliderPaginationBase,
  SliderWrapper,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {ProductsSlider} from '../../../features/HubPage/Sections/Products/ProductsSlider';
import {InteractiveProductTile} from '../../../features/ProductTile/InteractiveProductTile';

interface ProductsSectionProps extends ProductsSectionType {
  streamPosition: number;
  onAddToBasketCtaClick?: ({productId}: {productId: number}) => void;
  trackComponentConfig: TrackComponentParamsType;
}

export const ProductsSection: React.FC<ProductsSectionProps> = ({
  subline,
  streamPosition,
  trackComponentConfig,
  ...rest
}) => {
  const {device} = useConfig();

  return (
    <RowSection data-testid="productSection">
      <StyledProductsSlider
        constrained={device === 'desktop'}
        disableHeaderControl={device === 'mobile'}
        SlideControlComponent={
          device === 'desktop' ? SliderPaginationBase : undefined
        }
        ProductTileComponent={
          device === 'desktop' ? InteractiveProductTile : undefined
        }
        streamPosition={streamPosition}
        topline={subline}
        slideCount={1.5}
        trackComponentConfig={trackComponentConfig}
        {...rest}
      />
    </RowSection>
  );
};

const StyledProductsSlider = styled(ProductsSlider)`
  --bottom-spacing: 50px;

  @media ${mediaTabletAndUp} {
    ${SliderWrapper} {
      margin-top: 24px;
      margin-bottom: calc(var(--bottom-spacing) * -1);
      padding-left: 0;
      padding-bottom: var(--bottom-spacing);
    }
  }
`;
